// extracted by mini-css-extract-plugin
export default {"galleryNotFound":"GalleryNotFound_galleryNotFound__jGJjJ","marginTop":"GalleryNotFound_marginTop__Z4ca7"};